import { useState } from 'react';

import { useAtom } from 'jotai';
import { Badge, Box, Drawer, IconButton } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import UploadsSidebar from '@components/DashboardShell/Uploads';
import { uploadsAtom } from '@/atoms/uploadsAtom';
import { layout } from '@/theme';
import { headerActionSx } from '../headerStyles';

const UploadsSidebarButton = () => {
  const [uploads] = useAtom(uploadsAtom);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const uploadCount = uploads.length;

  return (
    <Box sx={{ display: 'flex' }}>
      <Badge
        badgeContent={uploadCount}
        sx={{
          '& .MuiBadge-badge': {
            bgcolor: 'common.white',
            color: 'primary.dark',
          },
        }}
      >
        <IconButton
          sx={headerActionSx}
          aria-label={
            uploadCount > 0 ? `Uploads, ${uploadCount} in progress` : 'Uploads'
          }
          onClick={() => setDrawerOpen(true)}
        >
          <CloudUploadIcon />
        </IconButton>
      </Badge>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        ModalProps={{
          keepMounted: false,
        }}
        sx={{
          '& .MuiBackdrop-root': {
            top: `${layout.toolbarHeight}px`,
          },
          '& .MuiDrawer-paper': {
            top: `${layout.toolbarHeight}px`,
            width: { xs: '100%', sm: 380 },
            maxWidth: '100vw',
            height: `calc(100% - ${layout.toolbarHeight}px)`,
            borderLeft: '1px solid',
            borderColor: 'divider',
            bgcolor: 'background.default',
            boxSizing: 'border-box',
          },
        }}
      >
        <UploadsSidebar onClose={() => setDrawerOpen(false)} />
      </Drawer>
    </Box>
  );
};

export default UploadsSidebarButton;
